import { useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

// Timeout aumentado a 120 minutos para que no se cierre durante el entrenamiento
const ADMIN_TIMEOUT = 120 * 60 * 1000; // 120 minutos (2 horas)
const CLIENT_TIMEOUT = 120 * 60 * 1000; // 120 minutos (2 horas)

export const useInactivityTimeout = () => {
  const { user, logout } = useAuth();
  const timeoutRef = useRef(null);
  const warningRef = useRef(null);

  const getTimeout = useCallback(() => {
    if (!user) return null;
    return user.role === 'admin' ? ADMIN_TIMEOUT : CLIENT_TIMEOUT;
  }, [user]);

  const resetTimer = useCallback(() => {
    const timeout = getTimeout();
    if (!timeout) return;

    // Clear existing timers
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (warningRef.current) clearTimeout(warningRef.current);

    // Set warning 1 minute before logout
    warningRef.current = setTimeout(() => {
      // Could show a warning toast here
      console.log('Sesión a punto de expirar...');
    }, timeout - 60000);

    // Set logout timer
    timeoutRef.current = setTimeout(() => {
      console.log('Sesión cerrada por inactividad');
      logout();
    }, timeout);
  }, [getTimeout, logout]);

  useEffect(() => {
    if (!user) return;

    // Events that reset the timer
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    // Reset timer on activity
    const handleActivity = () => resetTimer();

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // Start initial timer
    resetTimer();

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (warningRef.current) clearTimeout(warningRef.current);
    };
  }, [user, resetTimer]);

  return { resetTimer };
};

export default useInactivityTimeout;
